module.exports = __webpack_public_path__ + "static/media/flag@2x.148b89b0.svg";